import { render } from "./ClientConfiguracionPlantillas.vue?vue&type=template&id=23215b5c&scoped=true"
import script from "./ClientConfiguracionPlantillas.vue?vue&type=script&lang=js"
export * from "./ClientConfiguracionPlantillas.vue?vue&type=script&lang=js"

import "./ClientConfiguracionPlantillas.vue?vue&type=style&index=0&id=23215b5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23215b5c"]])

export default __exports__